import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {SimpleResponse} from '../../models/responses/simpleResponse.model';

@Injectable({
  providedIn: 'root'
})
export class EquipmentManualsService {
  private API_URL = `${environment.protocol}${environment.IPAddress}/api/lookups`;

  constructor(
    private http: HttpClient
  ) { }

  updateEquipmentManual(manualFileName: string, manualContents: string): Observable<SimpleResponse> {
    return this.http.post<SimpleResponse>(`${this.API_URL}/manual-upload`, {'manualFileName': manualFileName, 'fileContents': manualContents});
  }
}
